/* eslint-disable vue/no-mutating-props */
<template>
  <template v-if="mode === 'edit'">
    <div
      class="py-2 single-line-field w-full"
      :class="[
        warning ? 'warning' : '',
        field.error ? 'my-2 px-2 rounded border-2 border-brand-red bg-brand-red bg-opacity-10' : ''
      ]"
      :name="field.name"
      :field-id="field.field_id"
      :required="field.required"
      :validate="field.validate"
    >
      <!-- START alert container -->
      <div v-if="warning" class="pt-2">
        <p class="text-brand-black">{{ warningMessage }}</p>
        <div class="px-2 md:w-1/3 m-auto py-3">
          <PrimaryButton @click="closeWarning">I understand</PrimaryButton>
        </div>
      </div>
      <!-- END alert container -->
      <label v-if="field.label" for="input" class="block">
        {{ field.label }}
        <span v-if="field.required" class="text-brand-red">*</span>
      </label>
      <SingleLineInput
        :placeholder="field.placeholder"
        :value="field.value"
        @input="updateValue"
        @blur="validateValue"
        :mask="shouldValidate"
      ></SingleLineInput>
      <template v-if="field.help_text">
        <p class="text-brand-mid-gray italic text-xs">{{ field.help_text }}</p>
      </template>
      <template v-if="field.error">
        <p class="text-brand-red py-1">{{ errorMessage }}</p>
      </template>
    </div>
  </template>
  <template v-if="mode === 'view'"> </template>
  <template v-if="mode === 'form_edit'">
    <div class="flex flex-col w-full">
      <SingleLineInput
        :placeholder="field.placeholder"
        :value="field.placeholder"
        @input="updateValue"
      ></SingleLineInput>
      <TextDisplayEditToggle
        :helpText="field.help_text"
        :type="'field_subtext'"
        @input="updateHelpText"
        :disabled="field.editable === false"
      />
    </div>
  </template>
</template>
<script>
import validator from "validator"

export default {
  props: {
    field: Object,
    mode: {
      type: String
    },
    stage: {
      type: String
    }
  },
  emits: ["update"],
  computed: {
    shouldValidate() {
      if (["zipcode", "phone"].includes(this.field.field_id)) {
        return this.field.field_id
      }
      return this.field.validate
    },
    isValid() {
      if (!this.field.value && this.field.required) {
        return false
      }

      if (this.field.value && !this.field.value.trim() && this.field.required) {
        return false
      }

      if (this.field.value && this.warning) {
        return false
      }

      if (this.field.value && this.field.validate) {
        if (this.field.validate === "phone" && this.field.value.length < 14) {
          return false
        }
        if (this.field.validate === "zipcode" && this.field.value.length < 5) {
          return false
        }
        if (this.field.validate === "email" && !validator.isEmail(this.field.value)) {
          return false
        }
      }
      return true
    }
  },
  data() {
    return {
      warning: false,
      warningMessage: "",
      errorMessage: ""
    }
  },
  methods: {
    closeWarning() {
      this.warning = false
    },
    updateValue(ev) {
      this.$emit("update", ev.target.value)
      this.validateValue()
    },
    updateHelpText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.help_text = ev.target.value
    },
    validateValue() {
      // TODO: Check field specific validation
      // 1. address: PO BOX, address without numbered street, special characters
      // 2. applicant first name: co-sign, special characters
      // 3. zip code: valid 5 digit zipcode
      if (this.field.name === "current_address__address1") {
        this.warningMessage =
          "It looks like you have entered a P.O. Box. In order to process reports, this should be a valid residential street address (Example: 1234 Hickory St.)"
        //Numbered street addresses only. If you are in a temporary address, please enter your most recent permanent address. (Example: 1234 Hickory St.)
        //Note: Any special characters in your answer can potentially create issues when processing reports.
      }
      if (this.field.name === "applicant__first_name") {
        this.warningMessage =
          "Note: This should be your first name only, exactly as it would appear on a legal document."
        //Note: Any special characters in your answer can potentially create issues when processing reports.
      }
      // if (this.field.name.indexOf("zip_code") >= 0) {
      // }
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = "This field is required."
          return
        }

        if (this.field.validate === "email" && !validator.isEmail(this.field.value)) {
          this.errorMessage = "Please enter a valid email address"
          return
        }
      } else {
        this.errorMessage = ""
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.warning {
  background: #fefae8;
  @apply px-2;
}
</style>
